import { Card } from 'antd';
import { ConsignmentOrderForm } from '../../components/ConsignOrder/ConsignOrderForm';
import { TitleBreadcrumbs } from '../../uiComponents/TitleBreadcrumbs';

export const ConsignOrder = () => {
  return (
    <Card bordered={true} title={<TitleBreadcrumbs />} className="gx-card">
      <ConsignmentOrderForm />
    </Card>
  );
};
